<!-- app-subdomain-creators\src\Components\NewsfeedCreatorPendingRejectModal.vue -->

<template>
  <Transition
    enter-active-class="ease-out duration-300"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isOpen"
      class="fixed inset-0 bg-zinc-100 bg-opacity-[0.80] flex justify-center items-center py-2 z-50"
      @click.self="handleCancel"
    >
      <div
        class="bg-[#fff] relative rounded-xl max-w-[550px] w-full mx-auto border-[1px] pt-5 pb-4 border-zinc-200 shadow-lg"
        @click.stop
      >
        <button
          @click="handleCancel"
          class="text-gray-800 hover:text-gray-900 absolute top-3 right-4 rounded-full bg-zinc-200 hover:bg-zinc-300 p-1"
        >
          <XMarkIcon class="w-6 h-6 font-bold" />
        </button>

        <div class="px-6 pb-3 w-full border-b border-zinc-300">
          <h3 class="text-[19px] font-semibold text-center text-zinc-950">
            Reject and delete this post?
          </h3>
        </div>

        <div class="px-6 pb-4 pt-2">
          <p class="text-sm text-zinc-800 font-light">
            Rejecting this pending post removes it from moderation and prevents
            it from being published. This action cannot be undone.
          </p>
        </div>

        <div class="px-5 pt-1 pb-1 flex justify-end gap-2">
          <button
            type="button"
            class="px-4 py-2 rounded-lg text-sm font-medium text-zinc-700 hover:bg-zinc-100"
            @click="handleCancel"
            :disabled="isSubmitting"
          >
            Cancel
          </button>

          <button
            type="button"
            class="px-4 py-2 rounded-lg text-sm font-medium text-white bg-[#2D8CFF] hover:bg-[#1f7aeb] disabled:bg-[#9bbef3] disabled:cursor-not-allowed w-40"
            @click="handleConfirm"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? 'Rejecting...' : 'Reject & Delete' }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { XMarkIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['cancel', 'confirm']);

const handleCancel = () => {
  if (props.isSubmitting) return;
  emit('cancel');
};

const handleConfirm = () => {
  if (props.isSubmitting) return;
  emit('confirm');
};
</script>
